// eslint-disable-next-line @typescript-eslint/no-namespace
namespace FasterRequest {
  export const METHOD_GET = 'GET';
  export const METHOD_POST = 'POST';
  export const METHOD_PUT = 'PUT';
  export const METHOD_HEAD = 'HEAD';
}

interface FasterRequest {
  readonly method: string;

  body?(): object;

  headers(): object;

  endpoint(): string;

  query(): string;
}

export default FasterRequest;
